import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'style'

const OPTIONS = [
  {
    value: 'I forget where I put things',
    translationKey: 'pages.onboarding.style.options.forgetful',
  },
  {
    value: 'I like clear systems & labels',
    translationKey: 'pages.onboarding.style.options.systematic',
  },
  {
    value: 'I need creative chaos',
    translationKey: 'pages.onboarding.style.options.creative',
  },
  {
    value: 'Still figuring it out',
    translationKey: 'pages.onboarding.style.options.figuring',
  },
  {
    value: 'Not sure yet',
    translationKey: 'pages.onboarding.style.options.unsure',
  },
]

export default function StylePage() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How would you describe your organizational style?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)

      // If user selected "unsure", navigate to unsure page
      if (value === 'Not sure yet') {
        navigate('/onboarding/unsure')
      } else {
        // For any other choice, navigate directly to obstacle page
        navigate('/onboarding/obstacle')
      }
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.style.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
